module.exports = __webpack_public_path__ + "img/Teaching-Research Case - Green - Selected.c75c3d11.png";